// Short messages at the bottom of the window: edits that could not be made, imports, exports.
import { create } from 'zustand';

export interface Toast {
  id: number;
  text: string;
  kind: 'info' | 'error';
}

export const useToasts = create<{ toasts: Toast[] }>(() => ({ toasts: [] }));

let next = 1;

export function toast(text: string, kind: Toast['kind'] = 'info'): void {
  const id = next++;
  useToasts.setState((s) => ({ toasts: [...s.toasts.slice(-3), { id, text, kind }] }));
  window.setTimeout(() => dismissToast(id), kind === 'error' ? 6000 : 3500);
}

export function dismissToast(id: number): void {
  useToasts.setState((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
}
